// extracted by mini-css-extract-plugin
module.exports = {"loggedInAvatarContainer":"LoggedInAvatar_loggedInAvatarContainer__vFWR5","initials":"LoggedInAvatar_initials__h9PXH"};